<div class="error-container">
    <div class="error-message-container">
        <img class="error-img" src="../../../assets/error.svg">
        Ошибка!  
        <p class="error-message"> {{ errorMessage }} </p>
    </div>
    <button class="error-ok-button" (click)="hideError()"> Понятно </button>
</div>